import { MountingMethod, MountingMethodRules, PlateType } from "../types";

/**
 * Check if a mounting method is allowed based on provided rules
 * with given plate type and height
 */
export const isMountingMethodAllowed = (
  method: MountingMethod,
  rules?: MountingMethodRules,
  plateType?: PlateType,
  height?: number,
): boolean => {
  const rule = rules?.[method];
  if (!rule) {
    return true;
  }
  if (!plateType && !height) {
    return false;
  }
  if (rule.plateTypes && (!plateType || !rule.plateTypes.includes(plateType))) {
    return false;
  }
  if (rule.minHeight && (!height || height < rule.minHeight)) {
    return false;
  }
  if (rule.maxHeight && (!height || height > rule.maxHeight)) {
    return false;
  }

  return true;
};
